(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["shb-mini-cart"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.shbMiniCartInit) return;
    window.shbMiniCartInit = true;

    var drawer = document.getElementById('shbMiniCart');
    if (!drawer) return;

    var body = drawer.querySelector('[data-cart-body]');
    var subtotalEl = drawer.querySelector('[data-cart-subtotal]');
    var checkoutBtn = drawer.querySelector('[data-cart-checkout]');

    var termsBox = drawer.querySelector('[data-cart-terms]');
    var termsError = drawer.querySelector('[data-cart-terms-error]');
    var termsLabel = termsBox ? termsBox.closest('.shb-minicart__terms') : null;
    var checkoutForm = drawer.querySelector('[data-cart-checkout-form]');

    if (termsBox) {
      termsBox.addEventListener('change', function () {
        if (termsBox.checked) {
          if (termsError) termsError.hidden = true;
          if (termsLabel) termsLabel.classList.remove('is-invalid');
        }
      });
    }
    if (checkoutForm) {
      checkoutForm.addEventListener('submit', function (e) {
        if (termsBox && !termsBox.checked) {
          e.preventDefault();
          if (termsError) termsError.hidden = false;
          if (termsLabel) termsLabel.classList.add('is-invalid');
          termsBox.focus();
        }
      });
    }

    var noteToggle = drawer.querySelector('[data-note-toggle]');
    var noteBox = drawer.querySelector('[data-note-box]');
    var noteField = drawer.querySelector('[data-cart-note]');
    var noteSaved = drawer.querySelector('[data-note-saved]');
    if (noteToggle) {
      noteToggle.addEventListener('click', function () {
        noteBox.hidden = !noteBox.hidden;
        if (!noteBox.hidden) noteField.focus();
      });
    }
    var noteSave = drawer.querySelector('[data-note-save]');
    if (noteSave) {
      noteSave.addEventListener('click', function () {
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ note: noteField.value })
        }).then(function () {
          noteSaved.hidden = false;
          noteToggle.textContent = noteField.value ? 'Edit order note' : 'Add order note';
          setTimeout(function () { noteSaved.hidden = true; noteBox.hidden = true; }, 1200);
        });
      });
    }

    var FREE_SHIP_CENTS = 9900;
    var shipBar = drawer.querySelector('[data-ship-bar]');
    var shipMsg = drawer.querySelector('[data-ship-msg]');
    var shipFill = drawer.querySelector('[data-ship-fill]');
    var shipTrack = drawer.querySelector('[data-ship-track]');

    function renderShipBar(cart) {
      if (!shipBar) return;
      if (!cart.items.length) { shipBar.hidden = true; return; }
      shipBar.hidden = false;
      var total = cart.total_price;
      var pct = Math.min(100, Math.round(total * 100 / FREE_SHIP_CENTS));
      shipFill.style.width = pct + '%';
      shipTrack.setAttribute('aria-valuenow', pct);
      if (total >= FREE_SHIP_CENTS) {
        shipBar.classList.add('is-free');
        shipMsg.innerHTML = 'You’ve unlocked <strong>FREE shipping!</strong>';
      } else {
        shipBar.classList.remove('is-free');
        shipMsg.innerHTML = 'Spend <strong>' + money(FREE_SHIP_CENTS - total) + '</strong> more for <strong>FREE shipping</strong>';
      }
    }

    var recsCache = {};

    function escapeHtml(s) {
      return String(s || '').replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }

    function renderRecs(products, cart) {
      var box = body.querySelector('[data-cart-recs]');
      if (!box) return;
      var inCart = {};
      cart.items.forEach(function (i) { inCart[i.product_id] = true; });
      var list = (products || []).filter(function (p) {
        return !inCart[p.id] && p.available && p.variants && p.variants.length;
      }).slice(0, 6);
      if (!list.length) { box.innerHTML = ''; return; }
      box.innerHTML =
        '<h3>You may also like</h3>' +
        '<div class="shb-minicart__recs-row">' +
        list.map(function (p) {
          var v = p.variants.find(function (x) { return x.available; }) || p.variants[0];
          var img = p.featured_image ? p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=120' : '';
          return (
            '<div class="shb-minicart__rec">' +
              (img ? '<img src="' + img + '" alt="' + escapeHtml(p.title) + '" loading="lazy">' : '') +
              '<div class="shb-minicart__rec-info">' +
                '<a class="shb-minicart__rec-title" href="' + p.url + '">' + escapeHtml(p.title) + '</a>' +
                '<div class="shb-minicart__rec-price">' + money(v.price) + '</div>' +
              '</div>' +
              '<button type="button" class="shb-minicart__rec-add" data-rec-add="' + v.id + '">Add</button>' +
            '</div>'
          );
        }).join('') +
        '</div>';
    }

    function loadRecs(cart) {
      if (!cart.items.length) return;
      var pid = cart.items[0].product_id;
      if (recsCache[pid]) { renderRecs(recsCache[pid], cart); return; }
      fetch('/recommendations/products.json?product_id=' + pid + '&limit=8&intent=related')
        .then(function (r) { return r.json(); })
        .then(function (data) {
          recsCache[pid] = data.products || [];
          renderRecs(recsCache[pid], cart);
        })
        .catch(function () {});
    }

    function updateCount(cart) {
      document.querySelectorAll('[data-cart-count]').forEach(function (el) {
        el.textContent = cart.item_count;
        el.style.display = cart.item_count > 0 ? 'flex' : 'none';
      });
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
    }

    function money(cents) {
      return '$' + (cents / 100).toFixed(2);
    }

    function render(cart) {
      if (checkoutBtn) checkoutBtn.disabled = !cart.items.length;
      renderShipBar(cart);
      if (noteField && document.activeElement !== noteField) {
        noteField.value = cart.note || '';
        if (noteToggle) noteToggle.textContent = cart.note ? 'Edit order note' : 'Add order note';
      }
      if (!cart.items.length) {
        body.innerHTML = '<div class="shb-minicart__empty">Your cart is empty.</div>';
        subtotalEl.textContent = money(0);
        return;
      }

      body.innerHTML = cart.items.map(function (item) {
        return (
          '<div class="shb-minicart__line" data-line-key="' + item.key + '">' +
            '<img class="shb-minicart__line-img" src="' + (item.image || '') + '&width=128" alt="' + item.product_title + '">' +
            '<div class="shb-minicart__line-info">' +
              '<a href="' + item.url + '" class="shb-minicart__line-title">' + item.product_title + '</a>' +
              (item.variant_title ? '<div class="shb-minicart__line-variant">' + item.variant_title + '</div>' : '') +
              '<div class="shb-minicart__line-row">' +
                '<div class="shb-minicart__line-stepper">' +
                  '<button type="button" data-line-minus>−</button>' +
                  '<span>' + item.quantity + '</span>' +
                  '<button type="button" data-line-plus>+</button>' +
                '</div>' +
                '<span class="shb-minicart__line-price">' + money(item.final_line_price) + '</span>' +
              '</div>' +
              '<button type="button" class="shb-minicart__line-remove" data-line-remove>Remove</button>' +
            '</div>' +
          '</div>'
        );
      }).join('') + '<div class="shb-minicart__recs" data-cart-recs></div>';

      subtotalEl.textContent = money(cart.total_price);
      loadRecs(cart);
    }

    function fetchCart() {
      return fetch('/cart.js').then(function (r) { return r.json(); }).then(render);
    }

    function changeLine(key, quantity) {
      body.style.opacity = '.5';
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity })
      })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          render(cart);
          body.style.opacity = '1';
          updateCount(cart);
        });
    }

    function openCart() {
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      fetchCart();
    }
    function closeCart() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    // Expose a direct global hook as a fallback, in case the custom event
    // listener below hasn't attached yet for any reason (script load order etc).
    window.shbOpenMiniCart = openCart;

    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-cart-toggle]')) { openCart(); return; }
      if (e.target.closest('[data-cart-close]')) { closeCart(); return; }

      var recAdd = e.target.closest('[data-rec-add]');
      if (recAdd) {
        recAdd.disabled = true;
        recAdd.textContent = 'Adding…';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(recAdd.getAttribute('data-rec-add'), 10), quantity: 1 }] })
        })
          .then(function () { return fetch('/cart.js'); })
          .then(function (r) { return r.json(); })
          .then(function (cart) { render(cart); updateCount(cart); })
          .catch(function () { recAdd.disabled = false; recAdd.textContent = 'Add'; });
        return;
      }

      var minus = e.target.closest('[data-line-minus]');
      var plus = e.target.closest('[data-line-plus]');
      var remove = e.target.closest('[data-line-remove]');

      if (minus || plus || remove) {
        var line = e.target.closest('[data-line-key]');
        var key = line.getAttribute('data-line-key');
        var currentQty = parseInt(line.querySelector('span').textContent, 10);
        if (remove) { changeLine(key, 0); }
        else if (plus) { changeLine(key, currentQty + 1); }
        else if (minus) { changeLine(key, currentQty - 1); }
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeCart();
    });

    document.addEventListener('shb:open-cart', openCart);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["shb-product-card"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.shbProductCardInit) return;
    window.shbProductCardInit = true;

    var WISHLIST_KEY = 'shb_wishlist';

    function getWishlist() {
      try { return JSON.parse(localStorage.getItem(WISHLIST_KEY)) || []; }
      catch (e) { return []; }
    }
    function saveWishlist(list) {
      localStorage.setItem(WISHLIST_KEY, JSON.stringify(list));
    }
    function refreshWishlistButtons() {
      var wishlist = getWishlist();
      document.querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
        var handle = btn.getAttribute('data-product-handle');
        btn.classList.toggle('is-active', wishlist.indexOf(handle) !== -1);
      });
    }

    function updateCartCount() {
      return fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          document.querySelectorAll('[data-cart-count]').forEach(function (el) {
            el.textContent = cart.item_count;
            el.style.display = cart.item_count > 0 ? 'flex' : 'none';
          });
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
          return cart;
        });
    }

    document.addEventListener('click', function (e) {
      // --- Wishlist toggle ---
      var wishBtn = e.target.closest('[data-wishlist-toggle]');
      if (wishBtn) {
        var handle = wishBtn.getAttribute('data-product-handle');
        var wishlist = getWishlist();
        var idx = wishlist.indexOf(handle);
        if (idx === -1) {
          wishlist.push(handle);
        } else {
          wishlist.splice(idx, 1);
        }
        saveWishlist(wishlist);
        refreshWishlistButtons();
        return;
      }

      // --- Add to cart: first click adds qty 1 and morphs into stepper ---
      var addBtn = e.target.closest('[data-add-to-cart]');
      if (addBtn && !addBtn.disabled) {
        var cta = addBtn.closest('[data-cart-cta]');
        var variantId = addBtn.getAttribute('data-variant-id');
        var input = cta.querySelector('[data-step-input]');

        addBtn.disabled = true;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
        })
          .then(function (r) { return r.json(); })
          .then(function () {
            input.value = 1;
            input.setAttribute('data-line-qty', 1);
            cta.classList.add('is-active');
            updateCartCount();
            if (typeof window.shbOpenMiniCart === 'function') {
              window.shbOpenMiniCart();
            } else {
              document.dispatchEvent(new CustomEvent('shb:open-cart'));
            }
          })
          .catch(function () { alert('Could not add to cart. Please try again.'); })
          .finally(function () { addBtn.disabled = false; });
        return;
      }

      // --- Stepper plus/minus: syncs with cart via /cart/change.js ---
      var stepBtn = e.target.closest('[data-step-plus], [data-step-minus]');
      if (stepBtn) {
        var cta2 = stepBtn.closest('[data-cart-cta]');
        var addBtn2 = cta2.querySelector('[data-add-to-cart]');
        var variantId2 = addBtn2.getAttribute('data-variant-id');
        var input2 = cta2.querySelector('[data-step-input]');
        var currentVal = parseInt(input2.value) || 1;
        var newVal = stepBtn.hasAttribute('data-step-plus') ? currentVal + 1 : currentVal - 1;

        if (newVal < 1) {
          // Remove line item entirely, revert to "Add to cart"
          fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: variantId2, quantity: 0 })
          }).then(function () {
            cta2.classList.remove('is-active');
            updateCartCount();
            if (typeof window.shbOpenMiniCart === 'function') window.shbOpenMiniCart();
          });
          return;
        }

        input2.value = newVal;
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId2, quantity: newVal })
        })
          .then(function (r) { return r.json(); })
          .then(function () {
            updateCartCount();
            if (typeof window.shbOpenMiniCart === 'function') window.shbOpenMiniCart();
          })
          .catch(function () { alert('Could not update cart. Please try again.'); });
      }
    });

    // On page load, check existing cart to pre-open the stepper for items already in cart
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-cta]').forEach(function (cta) {
          var addBtn = cta.querySelector('[data-add-to-cart]');
          var variantId = addBtn.getAttribute('data-variant-id');
          var line = cart.items.find(function (i) { return String(i.variant_id) === String(variantId); });
          if (line) {
            var input = cta.querySelector('[data-step-input]');
            input.value = line.quantity;
            cta.classList.add('is-active');
          }
        });
      });

    refreshWishlistButtons();
  })();
  } catch(e) { console.error(e); }
})();

})();
